import { useEffect, useState } from 'react'

// The Library on a phone (PhoneLibrary.dc.html) is its own layout below this width.
export const PHONE_QUERY = '(max-width: 760px)'

export function useMedia(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)
  useEffect(() => {
    const mq = window.matchMedia(query)
    const update = () => setMatches(mq.matches)
    update()
    mq.addEventListener('change', update)
    // some browsers and emulators skip the change event; a resize catches those
    window.addEventListener('resize', update)
    return () => { mq.removeEventListener('change', update); window.removeEventListener('resize', update) }
  }, [query])
  return matches
}

export const usePhone = () => useMedia(PHONE_QUERY)

// Admin's list beside its editor (Recordings, Webinars) stacks into 1 column at this width
// (admin-content.css), so the editor sits under the list
export const STACKED_QUERY = '(max-width: 980px)'
export const useStacked = () => useMedia(STACKED_QUERY)
